// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "d0b726d4b051bb25a143242a54a4a2f1" + ".js";
};